// extracted by mini-css-extract-plugin
export default {"table":"Table_table__vn+yI","vertical_separator":"Table_vertical_separator__Tvl0A","horizontal_separator":"Table_horizontal_separator__SdUH8","shimmer":"Table_shimmer__8WwTm"};